export default "__VITE_ASSET__Bhi7LQxD__"